<div class="app-modal-header">
    <h3 class="text-lg font-medium text-gray-100">{{ 'choose_payment_method'| translate }}</h3>
</div>
<div class="app-modal-body">
    <div>
        <div class="auth-box card">
            <div class="card-block container">
                <div class="flex justify-center gap-4">
                    <!-- Qiwi Payment Option -->
<!--                    <div-->
<!--                            class=" border-1 p-2 rounded-xl bg-card transition-colors duration-200 hover:bg-gray-600"-->
<!--                            [ngClass]="{'bg-gray-800 border border-2 border-primary': selectedPayment === 'qiwi'}"-->
<!--                            *ngIf="!hideQiwi"-->
<!--                            (click)="selectPaymentMethod('qiwi')">-->
<!--                        <a class="payment-item">-->
<!--                            <img loading="lazy" src="assets/image/payment/qiwi_logo.png" alt="qiwi">-->
<!--                        </a>-->
<!--                    </div>-->

                    <!-- Stripe Payment Option -->

                    <div
                            class=" p-2 rounded-xl bg-card transition-colors duration-200 hover:bg-gray-600"
                            [ngClass]="{'bg-gray-800 border-2 border  border-primary': selectedPayment === 'paymentGateway'}"
                            *ngIf="!hideStripe"
                            (click)="selectPaymentMethod('paymentGateway')">
                        <a class="payment-item">
                            <img loading="lazy" src="assets/image/payment/payment_credit_card.svg" alt="stripe">
                        </a>
                    </div>
                    @if (user){
                        <div
                                class=" p-2 rounded-xl bg-card transition-colors duration-200 hover:bg-gray-600"
                                [ngClass]="{'bg-gray-800 border-2 border  border-primary': selectedPayment === 'balance'}"
                                *ngIf="!hideStripe"
                                (click)="selectPaymentMethod('balance')">
                            <a class="payment-item">
                                <img loading="lazy" src="assets/image/payment/pay_from_balance.svg" alt="Balance">
                            </a>
                        </div>

                    }
                </div>
            </div>
        </div>
    </div>
</div>
